
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/t/[slug]",
      function () {
        return require("private-next-pages/sitemap/t/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/t/[slug]"])
      });
    }
  